import React from 'react';
import styles from './Toolbar.module.css';

const TOOLS = [
  { id: 'wl',      label: 'W/L',    hint: 'Window / Level (drag)' },
  { id: 'pan',     label: 'Pan',    hint: 'Pan' },
  { id: 'zoom',    label: 'Zoom',   hint: 'Zoom (scroll + drag)' },
  { id: 'measure', label: 'Meas',   hint: 'Measure' },
  { id: 'rotate',  label: 'Rot',    hint: 'Rotate 90°' },
  { id: 'invert',  label: 'Inv',    hint: 'Invert' },
  { id: 'reset',   label: 'Reset',  hint: 'Reset view' },
];

export default function Toolbar({ active, onSelect, onAction }) {
  return (
    <aside className={styles.toolbar}>
      {TOOLS.map(t => {
        const action = t.id === 'reset' || t.id === 'rotate' || t.id === 'invert';
        const isActive = active === t.id;
        return (
          <button
            key={t.id}
            title={t.hint}
            className={`${styles.tool} ${isActive ? styles.active : ''}`}
            onClick={() => action ? onAction?.(t.id) : onSelect?.(t.id)}
          >
            {t.label}
          </button>
        );
      })}
    </aside>
  );
}
